import { Base } from 'app/components/ui/Base'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Title } from 'app/components/ui/Title'
import { protectedRoutes } from 'app/routing/routes'
import React from 'react'
import styled, { useTheme } from 'styled-components'

export const PageNotFound = (): JSX.Element => {
  const theme = useTheme()

  return (
    <Base>
      <PageNotFoundContainer>
        <Title size={1} mb={2}>
          oh oh... {'\n'}qualcosa è andato storto!
        </Title>
        <Title size={2} color={theme.color.primari.ciano} mb={4}>
          La pagina che stai cercando {'\n'}non è stata trovata.
        </Title>
        <Button size='lg' to={protectedRoutes.dashboard.path}>
          Torna alla Homepage
        </Button>
      </PageNotFoundContainer>
    </Base>
  )
}

const PageNotFoundContainer = styled(Container)`
  text-align: center;
`
